export default "__VITE_ASSET__2odxJNNy__"